import { performanceNow } from '../utils/utils';

/**
 * 用于记录耗时
 * _startTime: 开始时间
 * _endTime: 结束时间
 * @class DurationItem
 */
class DurationItem {
  private _startTime: number;
  private _endTime: number;

  constructor() {
    this._startTime = 0;
    this._endTime = 0;
    this.start();
  }

  start() {
    if (this._startTime === 0) {
      this._startTime = performanceNow();
    }
  }

  stop() {
    if (this._endTime === 0) {
      this._endTime = performanceNow();
    }
  }

  getDuration() {
    if (this._endTime === 0) {
      return performanceNow() - this._startTime;
    }
    return this._endTime - this._startTime;
  }

  get startTime() {
    return this._startTime;
  }

  get endTime() {
    return this._endTime;
  }
}

export default DurationItem;
